/** @format */

import $ from "jquery";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { NavLink, Route, Routes, useParams } from "react-router-dom";
import {
  CloseOutlined,
  SearchOutlined,
  BlockOutlined,
} from "@ant-design/icons";

import Card from "../../../../components/Card";
import editgray from "../../../../icons/editgray.png";
import Chart3 from "../../../../components/Charts/Chart3";
import Map from "../../../../components/map/Googlemap/Map";
import ContentTop from "../../../../components/ContentTop";
import locationred from "../../../../icons/locationred2.png";
import locationgray from "../../../../icons/locationgray2.png";
import { user_data } from "../../../../components/functions/usr";

import Oylik from "./Oylik";
import Kunlik from "./Kunlik";
import Yillik from "./Yillik";
import Soatlik from "./Soatlik";
import Dekadalik from "./Dekadalik";
import { getEnv } from "../../../../lib/env";

function AqlliSuv(props) {
  const user = user_data();
  const link = useParams();
  const [menu, setMenu] = useState(1);
  const [data, setData] = useState([]);
  const [labels, setLabels] = useState([]);
  const [regions, setRegions] = useState([]);
  const [district, setDistrict] = useState(0);
  const [isfilter, setIsfilter] = useState(null);
  const [districts, setDistricts] = useState([]);
  const [locations, setLocations] = useState([]);
  const [activeList, setActiveList] = useState("");
  const [screenMode, setScreenMode] = useState(false);
  const [region, setRegion] = useState(user.region_id);
  const [filterStation, setFilterStation] = useState("");
  const [selectedRowKeys, setSelectedRowKeys] = useState("");

  useEffect(() => {
    const fetchHudud = async () => {
      try {
        const { data } = await axios.get(
          `${getEnv('REACT_APP_BASE_URL')}/v1/region/proxy/hududlar`,
          {
                headers: {
                    // O'zingizning tizimingizdagi token (masalan, localStorage'dan olingan)
                    'Authorization': 'Bearer ' + localStorage.getItem('sw_user_token') 
                }
            }
        );

        if (data) {
          // Kelgan ma'lumotlarni state-ga saqlaymiz
          setRegions(data.regions || []);
          setDistricts(data.districts || []);
        }
      } catch (e) {
        console.error("Xato", e);
      }
    };

    fetchHudud();

    const menuMap = {
      kunlik: 2,
      dekada: 3,
      oylik: 4,
      yillik: 5,
    };
    setMenu(menuMap[link["*"]] || 1);
  }, []);

  const close = () => {
    if (selectedRowKeys !== "") {
      $("tr.tr" + selectedRowKeys + " input")[0].checked = false;
      $("tr.tr" + selectedRowKeys).removeClass("active");
    }
    setSelectedRowKeys("");
  };

  const checkRegion = (v) => {
    setRegion(v);
    setDistrict(0);
  };

  const setSearchHandler = (text) => {
    let actives = 0;
    $("ul.stations-list li").each(function () {
      if (
        $(this)
          .children("span")[0]
          .innerText.toUpperCase()
          .indexOf(text.toUpperCase()) > -1
      ) {
        $(this)[0].style.display = "";
        actives++;
      } else {
        $(this)[0].style.display = "none";
      }
    });
    setActiveList(actives);
  };

  return (
    <div>
      <ContentTop>
        <ul className='content-top-left'>
          <li>Aqlli suv</li>
        </ul>

        <ul className='content-top-right menu'>
          <li>
            <button
              className={menu == 1 ? "active" : ""}
              onClick={() => {
                setMenu(1);
                close();
              }}>
              <NavLink to='/aqllisuv'>Soatlik</NavLink>
            </button>
          </li>

          <li>
            <button
              className={menu == 2 ? "active" : ""}
              onClick={() => {
                setMenu(2);
                close();
              }}>
              <NavLink to='/aqllisuv/kunlik'>Kunlik</NavLink>
            </button>
          </li>

          <li>
            <button
              className={menu == 3 ? "active" : ""}
              onClick={() => {
                setMenu(3);
                close();
              }}>
              <NavLink to='/aqllisuv/dekada'>10 kunlik</NavLink>
            </button>
          </li>

          <li>
            <button
              className={menu == 4 ? "active" : ""}
              onClick={() => {
                setMenu(4);
                close();
              }}>
              <NavLink to='/aqllisuv/oylik'>Oylik</NavLink>
            </button>
          </li>

          <li>
            <button
              className={menu == 5 ? "active" : ""}
              onClick={() => {
                setMenu(5);
                close();
              }}>
              <NavLink to='/aqllisuv/yillik'>Yillik</NavLink>
            </button>
          </li>
        </ul>
      </ContentTop>

      <div className='row'>
        <div className='col-md-9'>
          <Routes>
            <Route
              path='/'
              element={
                <Soatlik
                  setLocations={setLocations}
                  setLabels={setLabels}
                  region={user.region_id}
                  district={district}
                  setData={setData}
                  data={data}
                  selectedRowKeys={selectedRowKeys}
                  setSelectedRowKeys={setSelectedRowKeys}
                />
              }
            />

            <Route
              path='/kunlik'
              element={
                <Kunlik
                  setLocations={setLocations}
                  setLabels={setLabels}
                  region={user.region_id}
                  district={district}
                  setData={setData}
                  data={data}
                  selectedRowKeys={selectedRowKeys}
                  setSelectedRowKeys={setSelectedRowKeys}
                />
              }
            />

            <Route
              path='/dekada'
              element={
                <Dekadalik
                  setLocations={setLocations}
                  setLabels={setLabels}
                  region={user.region_id}
                  district={district}
                  setData={setData}
                  data={data}
                  selectedRowKeys={selectedRowKeys}
                  setSelectedRowKeys={setSelectedRowKeys}
                />
              }
            />

            <Route
              path='/oylik'
              element={
                <Oylik
                  setLocations={setLocations}
                  setLabels={setLabels}
                  region={user.region_id}
                  district={district}
                  setData={setData}
                  data={data}
                  selectedRowKeys={selectedRowKeys}
                  setSelectedRowKeys={setSelectedRowKeys}
                />
              }
            />

            <Route
              path='/yillik'
              element={
                <Yillik
                  setLocations={setLocations}
                  setLabels={setLabels}
                  region={user.region_id}
                  district={district}
                  setData={setData}
                  data={data}
                  selectedRowKeys={selectedRowKeys}
                  setSelectedRowKeys={setSelectedRowKeys}
                />
              }
            />
          </Routes>

          {selectedRowKeys.length === 0 ? null : (
            <div
              className='data-content mt-3 mainpage'
              style={{ position: "relative" }}>
              <CloseOutlined
                style={{
                  position: "absolute",
                  top: 0,
                  right: 10,
                  zIndex: 9,
                  fontSize: "20px",
                  cursor: "pointer",
                }}
                onClick={close}
              />

              <Card
                additionalClass={screenMode ? "full-screen" : "simple-screen"}>
                <div className='screenMode'>
                  <BlockOutlined onClick={() => setScreenMode(!screenMode)} />
                </div>

                <div className='mapBlock'>
                  <Map
                    stations={locations}
                    center={{
                      lat: parseFloat(data[selectedRowKeys].lat),
                      lng: parseFloat(data[selectedRowKeys].lan),
                    }}
                    isfilter={isfilter}
                  />
                </div>
              </Card>

              <Chart3 datas={data[selectedRowKeys]["data"]} labels={labels} />
            </div>
          )}
        </div>

        <div className='col-md-3'>
          <div className='card-smartwater mt-3'>
            <div className='row'>
              {/*<div className="col-6 no-scrollBar" style={{maxHeight:"402px",overflow:"auto"}}>*/}
              {/*    <div className="details-box-left-change">*/}
              {/*        <ul id="regionList">*/}
              {/*            <li>Viloyat</li>*/}
              {/*            {*/}
              {/*                regions.length ?*/}
              {/*                    regions.map((r,i)=>{*/}
              {/*                        return <li key={i}>*/}
              {/*                                <button>*/}
              {/*                                    <label htmlFor={"regradio"+i}>*/}
              {/*                                    <input*/}
              {/*                                        type="radio"*/}
              {/*                                        name="regs"*/}
              {/*                                        onChange={e=>checkRegion(r.id)}*/}
              {/*                                        id={"regradio"+i}*/}
              {/*                                        checked={r.id==region}*/}
              {/*                                    />*/}
              {/*                                    {r.vil_nomi}*/}
              {/*                                    </label>*/}
              {/*                                </button>*/}
              {/*                        </li>*/}
              {/*                    }):null*/}
              {/*            }*/}
              {/*        </ul>*/}
              {/*    </div>*/}
              {/*</div>*/}

              <div
                className='ps-0 col-12 no-scrollBar'
                style={{ maxHeight: "402px", overflow: "auto" }}>
                <div className='details-box-left-change'>
                  <ul>
                    <li>Tuman</li>

                    <li>
                      <button>
                        <label htmlFor='disradio'>
                          <input
                            type='radio'
                            name='distr'
                            onChange={() => setDistrict(0)}
                            id='disradio'
                            checked={district == 0}
                          />
                          Barchasi
                        </label>
                      </button>
                    </li>

                    {districts.length
                      ? districts.map((d, i) => {
                          if (
                            d.vil_id == region ||
                            (!region && d.vil_id == 1)
                          ) {
                            return (
                              <li key={i}>
                                <button>
                                  <label htmlFor={"disradio" + i}>
                                    <input
                                      type='radio'
                                      name='distr'
                                      onChange={() => setDistrict(d.id)}
                                      id={"disradio" + i}
                                      checked={d.id == district}
                                    />
                                    {d.tum_nomi}
                                  </label>
                                </button>
                              </li>
                            );
                          } else return null;
                        })
                      : null}
                  </ul>
                </div>
              </div>
            </div>

            <div className='smartwater-search'>
              <input
                id='bbr'
                type='input'
                placeholder='Kuzatuv stansiyasi'
                value={filterStation}
                onChange={(e) => {
                  setFilterStation(e.target.value);
                  setSearchHandler(e.target.value);
                }}
              />

              <span>
                soni: {activeList === "" ? data.length : activeList}/
                {data.length} ta
              </span>

              <label htmlFor='bbr'>
                <SearchOutlined style={{ color: "#6E8BF5" }} />
              </label>
            </div>

            <div className='row'>
              <div className='details-box-left-change _details-box-left-change'>
                <ul className='stations-list'>
                  {data.length
                    ? data.map((d, i) => {
                        return (
                          <li
                            key={i}
                            className={d.location ? "active-location" : ""}
                            onClick={() => setSelectedRowKeys(i)}>
                            <span>
                              {d.location ? (
                                <img src={locationred} alt='404' />
                              ) : (
                                <img src={locationgray} alt='404' />
                              )}
                              &nbsp;&nbsp;
                              <img src={editgray} alt='404' />
                              &nbsp;&nbsp;
                              {d.name}
                            </span>
                            <span className='text-danger'>{d.volume}</span>
                          </li>
                        );
                      })
                    : null}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AqlliSuv;
